/**
 * Full webpack restart is required to update variables in html templates
 * In html files use it as: <%= htmlWebpackPlugin.options.VERSION %>
 */
var env = process.env.NODE_ENV;

var config = {
    production : {
        NODE_ENV: 'production',
        CAPTCHA_TOKEN : '6LdQ4LgZAAAAAELZwaC8efjUpzWz9l1kcbmv437Q',

    },
    development: {
        NODE_ENV: 'development',
        CAPTCHA_TOKEN : '6LdQ4LgZAAAAAELZwaC8efjUpzWz9l1kcbmv437Q',
    },
    test: {
        NODE_ENV: 'test',
        CAPTCHA_TOKEN : '6LdQ4LgZAAAAAELZwaC8efjUpzWz9l1kcbmv437Q',
    },
    win:{
        NODE_ENV: 'development',
        CAPTCHA_TOKEN : '6LdQ4LgZAAAAAELZwaC8efjUpzWz9l1kcbmv437Q',
    },
}


/**
 * VERSION and BUILD_TAG are added to htmlWebpackPlugin.options automatically during webpack build/bootstrap in vue.config.js
 */
var generated = {'VERSION': '#no version set#', 'BUILD_TAG ':'#no build tag set#'};
if(typeof window != "undefined"){
    if(window['_frontendVersion'] !== undefined){
        generated['VERSION'] = window['_frontendVersion'];
    }
    if(window['_frontendBuildTag'] !== undefined){
        generated['BUILD_TAG'] = window['_frontendBuildTag'] ;
    }
}
if(env === 'win'){
    generated['IS_WIN'] = 1;
}
// console.log(env);
module.exports = Object.assign(config[env], generated);
